import React from "react";
import { connect } from "react-redux";
import { FormattedMessage, injectIntl } from "react-intl";
import DateUtil from "../../../../util/DateUtil";
import { resetRgpd } from "../../../../actions/rgpd/rgpd";
import {
  blockCompany,
  testCompanyCrmSettings,
  updateCompanyCrmByField,
} from "../../../../actions/clients/company/company";
import CrmSoftwareList from "../../../../enums/CrmSoftware";
import { Button, OverlayTrigger, Tooltip } from "react-bootstrap";
import Icon from "../../../sub/Icon";

class CompanyListingRow extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      modal: null,
      data: null,
      field: null,
    };
  }

  changeAgence(e) {
    let c = { id: null, name: null };
    c.id = e.target.value;
    c.name = e.target.selectedOptions[0].label;
    this.setState({ data: c, field: "crm.options.lomaco.agence" });
  }

  ResetRGPD = (company_id) => {
    var data = { company_id: company_id };
    this.props.onResetRgpd(data);
  };

  blockCompany = (company_id) => {
    var data = { company_id: company_id };
    this.props.onBlockCompany(data);
  };

  closeModal() {
    this.setState({ modal: null });
  }

  openInformationModal(status, info) {
    if (this.props.company.crm.software === CrmSoftwareList.Must) {
      let versionAPI =
        info.GetVersionAPIResult && info.GetVersionAPIResult.VersionAPI;
      let versionG5 =
        info.GetVersionAPIResult && info.GetVersionAPIResult.VersionG5;
      let modalTitle = info.GetVersionAPIResult ? (
        info.GetVersionAPIResult.Erreur.HasAnyError !== true ? (
          <FormattedMessage id="Success" />
        ) : (
          <FormattedMessage id="Unexpected.Error" />
        )
      ) : (
        <FormattedMessage id="Unexpected.Error" />
      );
      let modalContent = info.GetVersionAPIResult ? (
        info.GetVersionAPIResult.Erreur.HasAnyError !== true ? (
          <>
            <p>
              <FormattedMessage id="API.Version" /> {versionAPI._Major}.
              {versionAPI._Minor}.{versionAPI._Build}.{versionAPI._Revision}
            </p>
            <p>
              <FormattedMessage id="API.CRM.Version" /> {versionG5._Major}.
              {versionG5._Minor}.{versionG5._Build}.{versionG5._Revision}
            </p>
          </>
        ) : (
          <>
            <p>
              <FormattedMessage id="API.CRM.Connection.Error" />
            </p>
            <p>
              <FormattedMessage id="API.CRM.Connection.Error.Verify" />
            </p>
          </>
        )
      ) : (
        <>
          <p>
            <FormattedMessage id="API.CRM.Connection.Error" />
          </p>
          <p>
            <FormattedMessage id="API.CRM.Connection.Error.Verify" />
          </p>
        </>
      );
      if (
        status === 200 &&
        info.GetVersionAPIResult &&
        info.GetVersionAPIResult.Erreur.HasAnyError !== true
      ) {
        this.props.openNotifModal(modalTitle, modalContent);
      } else {
        this.props.openErrorModal(modalTitle, modalContent);
      }
    } else if (this.props.company.crm.software === CrmSoftwareList.Lomaco) {
      let modalTitle = null;
      let modalContent = null;
      if (status === 200) {
        modalTitle = <FormattedMessage id="API.CRM.Connection.Offices" />;
        modalContent = (
          <>
            <label>
              <FormattedMessage id="API.CRM.Connection.Offices.Choice" />
            </label>
            <select
              className="form-control"
              name="agences"
              id="agence"
              onChange={(e) => {
                this.changeAgence(e);
              }}
            >
              <option key={0} value="0">
                {this.props.intl.formatMessage({ id: "Select" })}
              </option>
              {info.map((r) => {
                return (
                  <option key={r.id} value={r.id}>
                    {r.nomAgence}
                  </option>
                );
              })}
            </select>
          </>
        );

        this.props.openConfModal(modalTitle, modalContent, () => {
          this.props.onUpdateCompanyCrmByField(
            {
              field: this.state.field,
              data: this.state.data,
              company_id: this.props.company._id,
            },
            () =>
              this.props.openNotifModal(
                <FormattedMessage id="Successful.Connection" />,
                <FormattedMessage id="API.CRM.Connection.Lomaco" />,
              ),
            () =>
              this.props.openErrorModal(
                <FormattedMessage id="Unknown.Error.Title" />,
                <FormattedMessage id="Unknown.Error.Content" />,
              ),
          );
        });
      } else {
        modalTitle = <FormattedMessage id="API.CRM.Connection.Error" />;
        modalContent = (
          <FormattedMessage id="API.CRM.Connection.Error.Verify" />
        );
        this.props.openErrorModal(modalTitle, modalContent);
      }
    } else {
      this.props.openErrorModal(
        <FormattedMessage id="Unexpected.Error" />,
        <FormattedMessage id="API.CRM.Connection.Error" />,
      );
    }

    //console.log(fail);
  }

  getGroupName() {
    if (!this.props.company.group_id) return "-";

    const group = this.props.groups.find(
      (g) => g._id === this.props.company.group_id,
    );

    return group ? group.name : "-";
  }

  render() {
    //*************** RESET MODAL ELEMENT **************/
    var resetTitle = (
      <span>
        <FormattedMessage id="RGPD.Reset.Title" />
      </span>
    );
    var resetContent = (
      <p className="text-justify">
        <FormattedMessage id="RGPD.Reset.Content" />
      </p>
    );

    var resetSuccessCallback = () => this.ResetRGPD(this.props.company._id);

    //*************** BLOCK MODAL ELEMENT **************/
    var blockTitle = (
      <span>
        <FormattedMessage id="Company.Block.Title" />
      </span>
    );
    var blockContent = (
      <p className="text-justify">
        <FormattedMessage id="Company.Block.Content" />
      </p>
    );
    //*************** UNBLOCK MODAL ELEMENT **************/

    var unblockTitle = (
      <span>
        <FormattedMessage id="Company.Unblock.Title" />
      </span>
    );

    var unblockContent = (
      <p className="text-justify">
        <FormattedMessage id="Company.Unblock.Content" />
      </p>
    );

    var blockSuccessCallback = () => this.blockCompany(this.props.company._id);
    //***************************************************/
    var company = this.props.company;
    var rgpd = this.props.rgpd;
    var RGPDReseted =
      rgpd.length > 0 &&
      rgpd.filter((item) => item.company_id === company._id).length > 0
        ? false
        : true;
    var companyBlocked =
      company.active === true || company.active === undefined ? false : true;

    //let testCrm = (company.crm && company.crm.software) ?

    return (
      <React.Fragment>
        <tr key={company._id}>
          <td className="align-middle">{company.name.toUpperCase()}</td>
          <td className="align-middle">{company.url}</td>
          <td className="align-middle">{this.getGroupName()}</td>
          <td className="align-middle">
            {company.createdAt !== undefined &&
              DateUtil.toDate(company.createdAt)}
          </td>
          <td className="align-middle">{company.crm.software}</td>
          <td className="align-middle text-center tdaction">
            <div className="btn-group" role="group">
              <OverlayTrigger
                delay={{ hide: 0, show: 0 }}
                overlay={(props) => (
                  <Tooltip {...props}>
                    {<FormattedMessage id="Users" />}
                  </Tooltip>
                )}
                placement="top"
              >
                <Button
                  id={"user" + company._id}
                  variant="outline-dark"
                  onClick={(e) => this.props.openUsersModal(company)}
                >
                  <Icon icon="user" />
                </Button>
              </OverlayTrigger>

              <OverlayTrigger
                delay={{ hide: 0, show: 0 }}
                overlay={(props) => (
                  <Tooltip {...props}>{<FormattedMessage id="Edit" />}</Tooltip>
                )}
                placement="top"
              >
                <Button
                  id={"edit" + company._id}
                  variant="outline-dark"
                  onClick={(e) => this.props.openEditModal(company)}
                >
                  <Icon icon="pen-to-square" />
                </Button>
              </OverlayTrigger>

              <OverlayTrigger
                delay={{ hide: 0, show: 0 }}
                overlay={(props) => (
                  <Tooltip {...props}>{<FormattedMessage id="RGPD" />}</Tooltip>
                )}
                placement="top"
              >
                <Button
                  id={"rgpd" + company._id}
                  variant={RGPDReseted ? "outline-dark" : "danger"}
                  disabled={RGPDReseted ? true : false}
                  onClick={(e) =>
                    this.props.openConfModal(
                      resetTitle,
                      resetContent,
                      resetSuccessCallback,
                    )
                  }
                >
                  <Icon icon="refresh" />
                </Button>
              </OverlayTrigger>

              <OverlayTrigger
                delay={{ hide: 0, show: 0 }}
                overlay={(props) => (
                  <Tooltip {...props}>
                    {<FormattedMessage id="Block" />}
                  </Tooltip>
                )}
                placement="top"
              >
                <Button
                  id={"block" + company._id}
                  variant={companyBlocked ? "danger" : "outline-dark"}
                  onClick={(e) =>
                    companyBlocked
                      ? this.props.openConfModal(
                          unblockTitle,
                          unblockContent,
                          blockSuccessCallback,
                        )
                      : this.props.openConfModal(
                          blockTitle,
                          blockContent,
                          blockSuccessCallback,
                        )
                  }
                >
                  <Icon icon="ban" />
                </Button>
              </OverlayTrigger>

              <OverlayTrigger
                delay={{ hide: 0, show: 0 }}
                overlay={(props) => (
                  <Tooltip {...props}>
                    {<FormattedMessage id="API.CRM.Connection" />}
                  </Tooltip>
                )}
                placement="top"
              >
                <Button
                  id={"test" + company._id}
                  variant={
                    company.crm && company.crm.software
                      ? company.crm.enabled
                        ? "success"
                        : "danger"
                      : "outline-dark"
                  }
                  disabled={company.crm && company.crm.software ? false : true}
                  onClick={() => {
                    let data =
                      company && company.crm
                        ? company.crm.credentials
                          ? company
                          : false
                        : false;
                    this.props.ontestCompanyCrmSettings(
                      data,
                      (status, info) => this.openInformationModal(status, info),
                      (status, info) => this.openInformationModal(status, info),
                    );
                  }}
                >
                  <Icon icon="plug" />
                </Button>
              </OverlayTrigger>
            </div>
          </td>
        </tr>
        {this.state.modal}
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    groups: state.groups,
    rgpd: state.rgpd,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onResetRgpd: (company_id) => dispatch(resetRgpd(company_id)),
    onBlockCompany: (company_id) => dispatch(blockCompany(company_id)),
    onUpdateCompanyCrmByField: (data, successCallback, failureCallback) =>
      dispatch(updateCompanyCrmByField(data, successCallback, failureCallback)),
    ontestCompanyCrmSettings: (data, successCallback, failureCallback) =>
      dispatch(testCompanyCrmSettings(data, successCallback, failureCallback)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(CompanyListingRow));
